var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C12.125 0.5 15.5 3.875 15.5 8C15.5 12.1562 12.125 15.5 8 15.5C3.84375 15.5 0.5 12.1562 0.5 8C0.5 3.875 3.84375 0.5 8 0.5ZM8 14C11.2812 14 14 11.3125 14 8C14 4.71875 11.2812 2 8 2C4.6875 2 2 4.71875 2 8C2 11.3125 4.6875 14 8 14ZM10.5 5.5C10.8125 5.78125 10.8125 6.25 10.5 6.53125L9.03125 8L10.5 9.5C10.8125 9.78125 10.8125 10.25 10.5 10.5312C10.2188 10.8438 9.75 10.8438 9.46875 10.5312L8 9.0625L6.5 10.5312C6.21875 10.8438 5.75 10.8438 5.46875 10.5312C5.15625 10.25 5.15625 9.78125 5.46875 9.5L6.9375 8L5.46875 6.53125C5.15625 6.25 5.15625 5.78125 5.46875 5.5C5.75 5.1875 6.21875 5.1875 6.5 5.5L8 6.96875L9.46875 5.5C9.75 5.1875 10.2188 5.1875 10.5 5.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInput);
export default __webpack_public_path__ + "static/media/Search Input.ec11ef2463ceb41ecd69108e81fd244e.svg";
export { ForwardRef as ReactComponent };